import React from "react";
import { connect } from "react-redux";
import QuestionV1 from "./QuestionV1";
import QuestionV2 from "./QuestionV2";
import QuestionInteractive from "./interactive/QuestionInteractive";
import QuestionInteractiveWrapper from "./interactive/QuestionInteractiveWrapper";
import {
  getCurrentQuestionAndStem,
} from "../../selectors/questionSelectors";
import { getCurrentLessonQuestionAndStem } from "../../selectors/lessonQuestionSelectors";
import { getQuestionStemsByQuestionId } from "../../selectors/questionStemSelectors";

function Question(props) {
  const { question, stems, currentEntry } = props;
  const isInteractive = question?.format === "interactive";

  // Flow pagination entry → wrapper renders InteractiveLayout with context on the left
  //   and QuestionInteractive on the right.
  // Stem pagination entry → wrapper renders InteractiveLayout with ConversationRecap on
  //   the left and QuestionV2 on the right (hybrid interactive with stems).
  if (isInteractive) {
    if (currentEntry?.isFlow) {
      return <QuestionInteractiveWrapper {...props} isFlow />;
    }
    if (currentEntry?.stem) {
      return <QuestionInteractiveWrapper {...props} isFlow={false} />;
    }
    // Default (e.g., search readOnly or no pagination context): full flow without layout
    return <QuestionInteractive {...props} />;
  }

  let version = question?.version;

  if (!version) {
    if (stems && stems.length > 0) {
      version = 2;
    } else {
      const hasReplies = question?.meta?.replies && question.meta.replies.length > 0;
      const hasContext = question?.context && question.context.trim().length > 0;
      const hasEmptyTitle = !question?.title || question.title.trim().length === 0;

      if (hasContext && !hasReplies && hasEmptyTitle) {
        version = 2;
      } else {
        version = 1;
      }
    }
  }

  if (version === 1) {
    return <QuestionV1 {...props} />;
  }

  if (version === 2) {
    return <QuestionV2 {...props} />;
  }

  return null;
}

function mapStateToProps(state, ownProps) {
  const { question, lesson } = ownProps;
  const stems = question?.id ? getQuestionStemsByQuestionId(state, question.id) : [];
  const currentEntry = lesson
    ? getCurrentLessonQuestionAndStem(state)
    : getCurrentQuestionAndStem(state);

  return {
    stems,
    currentEntry,
  };
}

export default connect(mapStateToProps)(Question);
